export class SettingsKeys {
  public static readonly inactivityTimeoutInMinutes = 'ClientSettings:InactivityTimeoutInMinutes';
  public static readonly isUnauthorized = 'IsUnauthorized';
}
